module.exports = "<app-header>   \r\n</app-header>\r\n\r\n<!-- <app-test>\r\n</app-test> -->\r\n\r\n <!-- <router-outlet></router-outlet> -->\r\n     \r\n\r\n\r\n<alert></alert>\r\n\r\n<!-- <app-about></app-about> -->\r\n<!-- <app-footer></app-footer> -->\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// C:/unnati/latestWebCode29march/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main